export default __webpack_public_path__ + "static/media/pattern04.dbf89955.svg";